import React, { useState, useEffect } from 'react';
import {useNavigate } from 'react-router-dom';
import {  FaCog, FaSignOutAlt, FaLifeRing, FaBan, faMoneyBill  } from 'react-icons/fa';
import useLogout from '../../Utilities/LogoutUser.js';

import avatar1 from '../Assets/avatar1.png';
import avatar2 from '../Assets/avatar2.png';
import avatar3 from '../Assets/avatar3.png';
import avatar4 from '../Assets/avatar4.png';
import avatar5 from '../Assets/avatar5.png';
import avatar6 from '../Assets/avatar6.png';
import avatar7 from '../Assets/avatar7.png';
import avatar8 from '../Assets/avatar8.png';
import avatar9 from '../Assets/avatar9.png';
import avatar10 from '../Assets/avatar10.png';
import avatar11 from '../Assets/avatar11.png';
import avatar12 from '../Assets/avatar12.png';


import profileImg from '../../../admin/Assets/Images/profileImg.png';


const NavAvatar = ({ user, onLogout, chatWindowVisible, setChatWindowVisible }) => {
  const navigate = useNavigate();
  const { name = '', picture = null } = user || {};
  const [selectedAvatar, setSelectedAvatar] = useState(picture || profileImg);
  const [showAvatarSelector, setShowAvatarSelector] = useState(false); 
  const [showPreferences, setShowPreferences] = useState(false); 
  const [viewSupport, setViewSupport] = useState(false); 
  
  // Use the imported images directly
  const defaultAvatars = [
    { id: 1, src: avatar1 },
    { id: 2, src: avatar2 },
    { id: 3, src: avatar3 },
    { id: 4, src: avatar4 },
    { id: 1, src: avatar5 },
    { id: 2, src: avatar6 },
    { id: 3, src: avatar7 },
    { id: 4, src: avatar8 },
    { id: 1, src: avatar9 },
    { id: 2, src: avatar10 },
    { id: 3, src: avatar11 },
    { id: 4, src: avatar12 }
  ];

  const handleAvatarSelect = (avatarSrc) => {
    setSelectedAvatar(avatarSrc);
    setShowAvatarSelector(false); 
    localStorage.setItem('selectedAvatar', avatarSrc);
  
    // Send the avatar URL to the service worker for caching
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: 'CACHE_AVATAR',
        avatarUrl: avatarSrc // This is already a URL generated by Webpack
      });
    }
  };

  const formatName = (fullName) => {
    if (!fullName.trim()) return 'User';
    const [first, ...last] = fullName.split(' ');
    
    // Capitalize first letter of first name and handle empty cases
    const formattedFirst = first && first[0] 
      ? `${first[0].toUpperCase()}.`
      : '';
    
    // Capitalize first letter of last name(s) while preserving the rest
    const formattedLast = last
      .filter(namePart => namePart.trim())
      .map(namePart => 
        namePart[0].toUpperCase() + namePart.slice(1).toLowerCase()
      )
      .join(' ');

    return `${formattedFirst} ${formattedLast}`.trim();
  };
  const togglePreferences = () => {
    setShowPreferences(!showPreferences);
  };
  
  const handleSupportToggle = (shouldShow) => {
    setChatWindowVisible(shouldShow);
    setShowPreferences(false);
  };

  const handleViewSupport = () => {
    setViewSupport(true);
    navigate('/support-services');

  };

  useEffect(() => {
    const savedAvatar = localStorage.getItem('selectedAvatar');
    if (savedAvatar) {
      setSelectedAvatar(savedAvatar);
    }
  }, []);




  return (
    <div className="nav-avatar-wrapper">
      {/* Profile Image */}
      <img 
        src={selectedAvatar} 
        alt="Profile" 
        className="profile-circle" 
        onClick={() => setShowAvatarSelector(true)}
        onError={(e) => e.target.src = profileImg}
      />
      
      {/* Dropdown */}
      <div className="nav-item dropdown pe-3">
        <a 
          className="nav-profile dropdown-toggle" 
          href="#" 
          id="userDropdown"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <span className="nav-avatar-name">
            {formatName(name)}
          </span>
        </a>
        
        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
          {!picture && (
            <li>
              <a 
                className="dropdown-item" 
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setShowAvatarSelector(true);
                }}
              >
              </a>
            </li>
          )}
          <li>
            <a 
              className="dropdown-item" 
              href="#" 
              onClick={(e) => {
                e.preventDefault();
                onLogout();
              }}
            >
              <FaSignOutAlt /> Logout
            </a>
          </li>

          <li><hr className="dropdown-divider" /></li>

          <li>
            <a 
              className="dropdown-item" 
              href="#" 
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowPreferences(!showPreferences);
              }}
            >
              <FaCog /> Preferences
            </a>
          </li>

          {showPreferences && (
            <>
              <li>
                <a 
                  className="dropdown-item ps-4" 
                  href="#" 
                  onClick={(e) => {
                    e.preventDefault();
                    handleSupportToggle(true);
                  }}
                >
                  <FaLifeRing className="enable-support-icon"  /> Enable Support
                </a>
              </li>
              <li>
                <a 
                  className="dropdown-item ps-4" 
                  href="#" 
                  onClick={(e) => {
                    e.preventDefault();
                    handleSupportToggle(false);
                  }}
                >
                  <FaBan className="disable-support-icon"  /> Disable Support 
                </a>
              </li>
              <li>
                <a 
                  className="dropdown-item ps-4" 
                  href="#" 
                  onClick={(e) => {
                    e.preventDefault();
                    handleViewSupport();
                  }}
                >
                  <faMoneyBill className="enable-support-icon"  /> View Plans
                </a>
              </li>
            </>
          )}
        </ul>
      </div>

      {/* Avatar Selector Popup */}
      {showAvatarSelector && (
        <div 
          className="avatar-selector-popup"  
          onClick={() => setShowAvatarSelector(false)}
        >
          <div 
            className="avatar-grid-container" 
            onClick={(e) => e.stopPropagation()}
          >
            <h6>Select an Avatar</h6>
            <div className="avatar-grid">
              {defaultAvatars.map(avatar => (
                <img
                  key={avatar.id}
                  src={avatar.src}
                  alt={`Avatar ${avatar.id}`}
                  className="avatar-option"
                  onClick={() => handleAvatarSelect(avatar.src)}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NavAvatar;